import React from 'react'
import NavBar from '../components/NavBar'
import Footer from '../components/Footer'

const Mobile = () => {
  return (
    <>
    <NavBar/>
    <div>Mobile</div>
    <Footer/>
    </>
  )
}

export default Mobile